// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/RouteModal/RouteInfoModal.module.css */

.RouteInfoModal_overlay__adblq {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.RouteInfoModal_modal__bSmru {
  background: #fff;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.RouteInfoModal_header__Suuc0 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.RouteInfoModal_header__Suuc0 h2 {
  margin: 0;
  font-size: 1.25rem;
}

.RouteInfoModal_header__Suuc0 button {
  background: transparent;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
}

.RouteInfoModal_body__g6WU5 {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.RouteInfoModal_body__g6WU5 label {
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
  color: #333;
}

.RouteInfoModal_body__g6WU5 input[type="text"],
.RouteInfoModal_body__g6WU5 input[type="time"],
.RouteInfoModal_body__g6WU5 input[type="number"] {
  margin-top: 4px;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.95rem;
}

.RouteInfoModal_body__g6WU5 input[readonly] {
  background-color: #f0f0f0;
}

.RouteInfoModal_error__e1I8k {
  color: #c00;
  font-size: 0.9rem;
  margin-bottom: 8px;
}

.RouteInfoModal_footer__2NTUw {
  padding: 12px 16px;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.RouteInfoModal_footer__2NTUw button {
  padding: 6px 14px;
  border: none;
  border-radius: 4px;
  font-size: 0.95rem;
  cursor: pointer;
}

.RouteInfoModal_footer__2NTUw button:first-of-type {
  background-color: #e0e0e0;
  color: #333;
}

.RouteInfoModal_footer__2NTUw button:last-of-type {
  background-color: #28a745;
  color: #fff;
}

.RouteInfoModal_footer__2NTUw button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Admin/RouteBuilder/RouteBuilderDetail/RouteInfoModal.module.css"],"names":[],"mappings":"AAAA,wDAAwD;;AAExD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* src/components/RouteModal/RouteInfoModal.module.css */\r\n\r\n.overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal {\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  width: 400px;\r\n  max-width: 90%;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 16px;\r\n  background-color: #f5f5f5;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.header h2 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.header button {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 1.25rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.body {\r\n  padding: 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.body label {\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-size: 0.9rem;\r\n  color: #333;\r\n}\r\n\r\n.body input[type=\"text\"],\r\n.body input[type=\"time\"],\r\n.body input[type=\"number\"] {\r\n  margin-top: 4px;\r\n  padding: 6px 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.body input[readonly] {\r\n  background-color: #f0f0f0;\r\n}\r\n\r\n.error {\r\n  color: #c00;\r\n  font-size: 0.9rem;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.footer {\r\n  padding: 12px 16px;\r\n  background-color: #f5f5f5;\r\n  border-top: 1px solid #ddd;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n}\r\n\r\n.footer button {\r\n  padding: 6px 14px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 0.95rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.footer button:first-of-type {\r\n  background-color: #e0e0e0;\r\n  color: #333;\r\n}\r\n\r\n.footer button:last-of-type {\r\n  background-color: #28a745;\r\n  color: #fff;\r\n}\r\n\r\n.footer button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `RouteInfoModal_overlay__adblq`,
	"modal": `RouteInfoModal_modal__bSmru`,
	"header": `RouteInfoModal_header__Suuc0`,
	"body": `RouteInfoModal_body__g6WU5`,
	"error": `RouteInfoModal_error__e1I8k`,
	"footer": `RouteInfoModal_footer__2NTUw`
};
export default ___CSS_LOADER_EXPORT___;
